import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const endPoint = 'updateChannelSubscriptions/';
const url = apiUrl + endPoint;

export interface UpdateChannelSubscriptionsRequest {
  OrgUUID: string;
  ChannelId: string;
  Subscriptions: string[];
}

export interface UpdateChannelSubscriptionsResponse {
  Success: boolean;
  Error: string | null;
}

const updateChannelSubscriptions = async (
  req: UpdateChannelSubscriptionsRequest,
  headerObj: headerObject
): Promise<UpdateChannelSubscriptionsResponse | null> => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrgUUID: req.OrgUUID,
        ChannelId: req.ChannelId,
        Subscriptions: req.Subscriptions,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    return data;
  } catch (err) {
    console.error('Error updating channel subscriptions:', err);
    return null;
  }
};

export default updateChannelSubscriptions;
